import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PageHeader, Row, Col, Modal } from 'antd';

import { get, isEqual } from 'lodash';

import TemplateList from './TemplateList';
import TemplateForm from './TemplateForm';

import { setData } from './actions';

import './index.scss';

class SurveyProvisioning extends React.Component {
  state = {
    templateId: undefined,
  };

  componentDidMount() {
    const {
      match,
      showSurveyForm,
      history,
    } = this.props;
    if (
      !showSurveyForm &&
      isEqual(get(match, ['path']), '/survey-provisioning/create')
    ) {
      history.push('/survey-provisioning');
      return;
    }
    const templateId = get(match, ['params', 'templateId']);

    if (templateId) this.setState({ templateId });
  }

  componentDidUpdate() {
    const { match, history } = this.props;
    const { templateId } = this.state;
    const id = get(match, ['params', 'templateId']);
    if (templateId != id) this.setState({ templateId: id });

    window.addEventListener('beforeunload', this.onRedirect);
    this.unblock = history.block(this.onRedirect);
  }

  componentWillUnmount() {
    const { setData } = this.props;
    setData({
      showSurveyForm: false,
      surveyData: undefined,
      singleTemplate: undefined,
      preSelectedHubs: [],
    });
  }

  onRedirect = e => {
    const { setData, singleTemplate = {} } = this.props;
    const { isDirty = false, id } = singleTemplate;
    if (isDirty) {
      if (e.preventDefault) {
        e.preventDefault && e.preventDefault();
        e.stopImmediatePropagation && e.stopImmediatePropagation();
      } else {
        setData({ redirectModalPath: e.pathname });
        return false;
      }
    } else {
      this.cleanUp();
    }
  };

  cleanUp = () => {
    const { redirectModalPath, setData, history, showSurveyForm } = this.props;
    this.unblock && this.unblock();
    window.removeEventListener('beforeunload', this.onRedirect);
    setData({ redirectModalPath: undefined });
    if (redirectModalPath) {
      if (showSurveyForm) {
        setData({
          showSurveyForm: false,
          surveyData: undefined,
          singleTemplate: undefined,
          preSelectedHubs: [],
        });
      }
      history.push(redirectModalPath);
    }
  };

  confirmModal = () => {
    const { redirectModalPath, setData, history } = this.props;
    if (!redirectModalPath) return true;

    return (
      <Modal
        title="Are you sure?"
        closable
        visible={!!redirectModalPath}
        cancelText="Cancel"
        onCancel={() => setData({ redirectModalPath: undefined })}
        destroyOnClose
        okText="Continue"
        onOk={() => this.cleanUp()}
      >
        <h3>You have unsaved changes that will be lost if you leave.</h3>
      </Modal>
    );
  };

  render() {
    const { templateId } = this.state;
    const { showSurveyForm } = this.props;
    return (
      <div className="survey-provisioning">
        <PageHeader title="Survey Provisioning" />
        <Row className="container" gutter={{ lg: 25 }}>
          <Col span={12}>
            <TemplateList templateId={templateId} />
          </Col>
          <Col span={12}>
            {showSurveyForm ? <TemplateForm templateId={templateId} /> : null}
          </Col>
        </Row>
        <this.confirmModal />
      </div>
    );
  }
}

const mapStateToProps = ({ surveyProvisioningReducer }) => surveyProvisioningReducer;

const mapDispatchToProps = {
  setData,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SurveyProvisioning)
);
